import tree from './icons/tree'
import fingerbank from './icons/fingerbank'

export default {
  ...tree,
  ...fingerbank
}